
'use strict';

var $ = require('jquery');
var config = require('../config');
var $global = require('../globalElements');
var $htmlBody = $global.$htmlBody;
var $window = $global.$window;
var mediator = require('mediatorjs');
var _ = require('underscore');
var Backbone = require('backbone');

const ITEM_IS_INITIALIZED_CLASS = 'JumpTo-item--isInitialized';

const JumpToNav = Backbone.View.extend({

  initialize: function() {
    this.updateHeaderHeight();
    mediator.on(config.events.ui.resize, this.updateHeaderHeight, this);
    this.renderJumpLinks();
    mediator.on(config.events.ui.ajaxContentLoaded, this.renderJumpLinks, this);
    this.showJumpSection();
  },

  showJumpSection: function() {
    this.title = false;
    this.$('.JumpTo-item').each((i, jumpLinkItemElement) => {
      if ($(jumpLinkItemElement).hasClass(config.classes.isVisible)) {
        this.title = true;
      }
    });
    if (!this.title && this.$el.hasClass('JumpTo')) {
      this.$el.hide();
    }
  },

  renderJumpLinks: function() {
    if (!this.$el.hasClass('JumpTo--tutorial')) {
      this.$('.JumpTo-item').each((i, jumpLinkItemElement) => {
        this.renderSingleJumpLink(jumpLinkItemElement);
      });
    } else {
      this.$el.find('li').addClass(config.classes.isVisible);
    }
  },

  renderSingleJumpLink: function(jumpLinkItemElement) {
    var $item = $(jumpLinkItemElement),
      $link = $item.find('a'),
      isItemInitialized = $item.hasClass(ITEM_IS_INITIALIZED_CLASS),
      contentId = $link.attr('href');

    // Only proceed if there is a url fragment
    if (contentId.indexOf('#') !== 0) {
      return;
    }

    this.updateLinkVisibility($item, contentId);

    if (!isItemInitialized) {
      $link.on('click', (e) => {
        e.preventDefault();
        this.scrollToContent($item, contentId);
      });
      $item.addClass(ITEM_IS_INITIALIZED_CLASS);
    }
  },

  // Bigger scroll offset if it's sticky header
  updateHeaderHeight: function() {
    var extraOffset = 5;
    if ($window.width() >= config.minimisedHeader.breakpoint) {
      this.headerOffset = config.headerHeight.desktopMinimised + extraOffset;
    } else {
      this.headerOffset = extraOffset;
    }
  },

  scrollToContent: function($item, contentId) {
    var self = this;

    this.$('.' + config.classes.isActive).removeClass(config.classes.isActive);
    $item.addClass(config.classes.isActive);

    $htmlBody.animate({
      scrollTop: $(contentId).offset().top - self.headerOffset
    }, 500);
  },

  // Hides link item if related content is empty
  updateLinkVisibility: function($item, contentId) {
    if ($(contentId).children().length) {
      $item.removeClass(config.classes.isHidden);
      $item.addClass(config.classes.isVisible);
    } else {
      $item.addClass(config.classes.isHidden);
      $item.removeClass(config.classes.isVisible);
    }
  }

}, {
  create: function($parent) {
    _.defer(function() {
      $parent.find('.JumpTo').each(function() {
        new JumpToNav({
          el: this
        });
      });
    });
  }
});

module.exports = JumpToNav;



// WEBPACK FOOTER //
// ./assets/js/navigation/jumpTo.js